export default "__VITE_ASSET__ed66a259__"